export function pickFooter() {
  return import(/* webpackChunkName: "footer" */ "./components/layouts/footer/render-footer-component.js");
}
